export default __webpack_public_path__ + "static/NoiseTexture-db8b66b8af2fad2a51d9b779a68d8d09.png";